// api/config.js
class ApiConfig {
  static get BASE_URL() {
    return process.env.REACT_APP_API_BASE_URL || "";
  }

  static get API_VERSION() {
    return process.env.REACT_APP_API_VERSION || "v1";
  }

  static get ENDPOINTS() {
    return {
      //SignUp
      CHECKTOKEN: `${this.BASE_URL}${this.API_VERSION}/SetInProgress`,
      SIGNUP: `${this.BASE_URL}${this.API_VERSION}/SignUpUser`,
      // Auth endpoints
      LOGIN: `${this.BASE_URL}${this.API_VERSION}/LoginUser`,
      LOGOUT: `${this.BASE_URL}${this.API_VERSION}/LogoutUser`,
      //SIGNUP: `${this.BASE_URL}${this.API_VERSION}/RegisterUser`,
      REFRESH_TOKEN: `${this.BASE_URL}${this.API_VERSION}/RefreshToken`,
      FORGOT_PASSWORD: `${this.BASE_URL}${this.API_VERSION}/RequestResetPassword`,
      RESET_PASSWORD: `${this.BASE_URL}${this.API_VERSION}/ConfirmResetPassword`,

      // Business endpoints
      GET_BUSINESSES: `${this.BASE_URL}${this.API_VERSION}/GetBusinessesbyReseller`,
      GET_BUSINESS: `${this.BASE_URL}${this.API_VERSION}/GetBusiness`,
      ADD_BUSINESS: `${this.BASE_URL}${this.API_VERSION}/AddBusiness`,
      UPDATE_BUSINESS: `${this.BASE_URL}${this.API_VERSION}/UpdateBusiness`,
      IMPORT_BUSINESSES: `${this.BASE_URL}${this.API_VERSION}/UploadBusinessJson`,
      GET_BUSINESS_TYPES: `${this.BASE_URL}${this.API_VERSION}/GetBusinessTypes`,
      GET_BUSINESS_ACTIVITY_LOG: `${this.BASE_URL}${this.API_VERSION}/GetBusinessActivityLog`,

      // Terminal endpoints
      GET_FEECAPS: `${this.BASE_URL}${this.API_VERSION}/GetFeeCaps`,
      GET_TERMINALS: `${this.BASE_URL}${this.API_VERSION}/GetTerminals`,
      GET_SINGLE_TERMINAL: `${this.BASE_URL}${this.API_VERSION}/GetTerminalP`,
      UPSERT_TERMINAL: `${this.BASE_URL}${this.API_VERSION}/UpsertTerminal`,
      GET_TERMINAL_ACTIVITY_LOG: `${this.BASE_URL}${this.API_VERSION}/GetTerminalActivityLog`,

      //CreateEnrolmentCode endpoints
      CREATE_ENROLMENT_CODE: `${this.BASE_URL}${this.API_VERSION}/CreateEnrolmentCode`,

      //ClearTerminalLoginAttempts endpoints
      CLEAR_TERMINALS_LOGIN_ATTEMPTS: `${this.BASE_URL}${this.API_VERSION}/ClearTerminalLoginAttempts`,

      // Settings endpoints
      GET_BUSINESS_PROPERTIES: `${this.BASE_URL}${this.API_VERSION}/GetBusinessProperties`,
      UPDATE_BUSINESS_PROPERTIES: `${this.BASE_URL}${this.API_VERSION}/UpdateBusinessProperties`,

      //Dashboard report
      GET_SUMMARY_BY_RESELLER: `${this.BASE_URL}${this.API_VERSION}/GetSummarybyReseller`,

      //Dashboard report
      GET_SUMMARY_BY_TRANSACTION: `${this.BASE_URL}${this.API_VERSION}/GetTransactionsbyReseller`,

      //Permissions
      GET_MY_PERMISSIONS: `${this.BASE_URL}${this.API_VERSION}/GetPermissions`,
    };
  }
}

export default ApiConfig;
